import Cookies from 'js-cookie';

const {
  get: getCookie,
  getJSON: getCookieJSON,
  set: setCookie,
  remove: removeCookie,
} = Cookies.withConverter({
  read: function (value, name) {
    if (name.includes('docupet-order')) {
      return JSON.parse(value);
    }
    if (name === 'docupet-discount') return window.unescape(value);
    // Fall back to default for all other cookies
    return Cookies.converter.read(value, name);
  },
  write: function (value, name) {
    if (name.includes('docupet-order')) {
      return JSON.stringify(value);
    }
    return value;
  },
});

export const CookieMixins = {
  methods: {
    getCookie,
    getCookieJSON,
    setCookie,
    removeCookie,
    getBasketCookie() {
      // Read Basket Items
      const dpBasketCookies = [];
      Object.keys(this.getCookieJSON())
        ?.filter((key) => key.includes('docupet-order'))
        ?.forEach((key) => {
          dpBasketCookies.push(...this.getCookieJSON()[key]);
          removeCookie(key, { path: '/', domain: '.docupet.com', secure: true });
        });

      return dpBasketCookies;
    },
    setBasketCookie(basketItems) {
      // Re-write Basket Items
      const dpBasketCookiesChunks = [];
      const dpBasketCookiesRawChunk = [...basketItems];
      if (dpBasketCookiesRawChunk.length === 0) this.removeBasketCookie();
      while (dpBasketCookiesRawChunk.length > 0) dpBasketCookiesChunks.push(dpBasketCookiesRawChunk.splice(0, 15));
      dpBasketCookiesChunks.forEach((chunk, index) =>
        this.setCookie(`docupet-order-${index}`, chunk, { expires: 3, path: '/', domain: '.docupet.com', secure: true })
      );

      return Promise.resolve(basketItems);
    },
    splitSetBasket() {
      return this.setBasketCookie(this.getBasketCookie());
    },
    removeBasketCookie() {
      Object.keys(this.getCookieJSON())
        ?.filter((key) => key.includes('docupet-order'))
        ?.forEach((key) => removeCookie(key, { path: '/', domain: '.docupet.com', secure: true }));
    },
    getBasketCodeCookie() {
      return this.getCookieJSON()['docupet-discount'];
    },
    setBasketCodeCookie(code) {
      this.setCookie('docupet-discount', code, { expires: 3, path: '/', domain: '.docupet.com', secure: true });
    },
    removeBasketCodeCookie() {
      this.removeCookie('docupet-discount', { path: '/', domain: '.docupet.com', secure: true });
    },
  },
};
